/* eslint-disable tailwindcss/no-custom-classname */
import { Br } from "@/components/molecules/Br";
import Image from "next/image";
import careerSupportOffice from "/public/careerSupportOffice.webp";

const supports = [
  {
    title: "品質確保",
    src: "/careerSupport3.svg",
    desc: "品質向上タスクフォースを軸に、課題の収集や解決策の検討、プロセスや観点のカイゼンを続けます",
    sub: "",
  },
  {
    title: "教育推進",
    src: "/careerSupport4.svg",
    desc: "エンジニア研修はもちろん、社会人としてのマナー向上研修、資格取得推進制度があります ",
    sub: "入社時研修（ビジネスマナー等）・コミュニケーション研修。エンジニア研修は先輩社員や、現役エンジニアの弊社代表が講師を務めます",
  },
  {
    title: "技術向上",
    src: "/careerSupport1.svg",
    desc: "技術研究タスクフォースを中心に、業務で活用した技術に加え、未使用の技術も含め取り組んでいきます ",
    sub: "コンテナ技術/サーバレスアプリケーション/CI／CD/UIコンポーネント/ヘッドレスCMS/Jamstack/NoSQL/テスト自動化 など",
  },
  {
    title: "週末講習",
    src: "/careerSupport2.svg",
    desc: "隔週土曜日 or 日曜日に、任意参加で1時間30分程度の講習会を開催しています",
    sub: "",
  },
];
const cares = [
  {
    id: "1",
    title: "社内教育<br class='tbpc'/>プログラム",
    desc: "未経験の方でも、安心して技術を習得できる環境があります",
    sub: "",
  },
  {
    id: "2",
    title: "資格取得<br class='tbpc'/>推奨制度",
    desc: "資格取得の受験費を補助します。合格者には祝い金を支給します",
    sub: "",
  },
  {
    id: "3",
    title: "育休・産休・<br class='tbpc'/>介護休暇",
    desc: "取得実績のあるスタッフも複数おり、産休・育休の取得率は100%です",
    sub: "（育児における時短勤務延長制度有・小学3年生3月まで）",
  },
  {
    id: "4",
    title: "長期休暇",
    desc: "大型連休と有給休暇を組み合わせて、長期休暇の取得も可能です",
    sub: "",
  },
  {
    id: "5",
    title: "リモート<br class='tbpc'/>ワーク",
    desc: "出社もリモートも可能な「ハイブリットワーク」ができる環境を整えています",
    sub: "（業務状況によって出社での勤務もございます）",
  },
  {
    id: "6",
    title: "社員旅行",
    desc: "年に1度仕事を離れて、親睦を深めるために社員旅行に行きます",
    sub: "（任意参加で全額会社負担です）",
  },
];

const CareerEnvironment = () => {
  return (
    <>
      <div id="environment" className="--offset">
        <div className="relative mx-auto box-border max-w-7xl px-8  font-bold md:px-20">
          <div className="relative z-10 flex flex-col gap-4 md:max-w-7xl md:gap-6">
            <div className="space-y-4 md:space-y-8">
              <div className="font-bold">
                <h4 className=" text-ter fluid-text-[11px,16px]">福利厚生</h4>
                <h3 className=" text-ter fluid-text-[16px,22px] ">
                  Environment & Institution
                </h3>
              </div>
              <h2 className=" text-pri fluid-text-[22px,45px]">
                成長の場とするために
              </h2>
            </div>
            <div className="space-y-2 leading-comfort text-txt-light fluid-text-[16px,21px] md:space-y-5">
              <div>
                ToccaSystemsでは仕事を共にする仲間と、一緒に成長して行きたいと考えています。
                <Br pc />
                スタッフ・エンジニアに向けた、成長をサポートする制度と環境を用意しています。
              </div>
            </div>
            <div className="flex flex-col gap-2 md:gap-4">
              <h5 className="text-ter fluid-text-[14px,18px]">
                4つのサポート制度
              </h5>
              <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
                {supports.map((support) => (
                  <dl className="grid-flow-col grid-cols-1" key={support.index}>
                    <dt className="relative aspect-2/1">
                      <Image
                        src={support.src}
                        alt={support.title}
                        quality={80}
                        layout="fill"
                        objectFit="cover"
                      />
                    </dt>
                    <dd className="space-y-1 pt-2 font-normal">
                      <p className="text-sm text-txt-base">{support.desc}</p>
                      <p className="text-xs text-txt-light">{support.sub}</p>
                    </dd>
                  </dl>
                ))}
              </div>
            </div>
          </div>
          <div className="relative z-10 mt-6 flex flex-col gap-4 md:max-w-7xl md:gap-6">
            <h2 className=" text-pri fluid-text-[18px,26px]">
              安心して仕事をするためのケア
            </h2>
            <div className="space-y-2 font-normal leading-comfort text-txt-light fluid-text-[14px,18px] md:space-y-5">
              安心して仕事を続けられるために、私たちは様々な福利厚生を用意しています。
              <Br pc />
              <strong className="text-ylw">
                ルールは会社や社員の状況、また時節に合わせて柔軟に改善して参ります。
              </strong>
            </div>
            <div className="flex flex-col gap-2 md:gap-4">
              <h5 className="text-ter fluid-text-[14px,18px]">6つのケア制度</h5>
              <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-10">
                {cares.map((care) => (
                  <dl className="grid-flow-col grid-cols-1" key={care.index}>
                    <dt className="relative flex aspect-2/1 items-center justify-center rounded-full border border-solid border-bdc-accent text-center text-pri fluid-text-[14px,22px]">
                      <div
                        className="relative z-10"
                        dangerouslySetInnerHTML={{
                          __html: `${care.title}`,
                        }}
                      />
                      <div className="absolute top-0 left-0 z-0 -mt-2 flex h-full w-full items-center justify-center text-7xl leading-none text-ter/20 md:text-9xl">
                        {care.id}
                      </div>
                    </dt>
                    <dd className="space-y-1 pt-2 font-normal">
                      <p className="text-base text-txt-base">{care.desc}</p>
                      <p className="text-xs text-txt-light">{care.sub}</p>
                    </dd>
                  </dl>
                ))}
              </div>
            </div>
            <h2 className=" text-pri fluid-text-[18px,26px]">
              快適に仕事を続けるための環境
            </h2>
            <div className="space-y-2 font-normal leading-comfort text-txt-light fluid-text-[14px,18px] md:space-y-5">
              時節柄、リモートワークを推奨していますが、出社をして顔と顔を突き合わせて、
              <Br pc />
              共に仕事ができること、そのオフィスがあるということを、大切なことだと考えています。
            </div>
          </div>
        </div>
        <figure className="relative mt-6 aspect-4/1 md:mt-10">
          <Image
            src={careerSupportOffice}
            alt="弊社オフィス内観"
            quality={80}
            layout="fill"
            objectFit="cover"
          />
        </figure>
      </div>
    </>
  );
};

export default CareerEnvironment;
